import WorkflowStep from "./workflowStep";
import {WorkflowType} from "~/enums/forms/workflowSteps/workflowType";
import WorkflowStepInterface from "../../../../common/interfaces/workflowStepInterface";
import Validatable from "../../../../common/mixins/validatable";
import FormStepValidation from "../../../../common/models/navigableValidations/formStepValidation";

export default class FormStep extends Validatable(WorkflowStep) implements WorkflowStepInterface {
  dependent_form_id: string = '';
  dependent_form: any;

  constructor(form?) {
    super(form);
    this.defineProperty('workflow_type', WorkflowType.form);
    this.defineProperty('dependent_form_id', null);
  }


  //***** validation ***** //
  _validation: FormStepValidation = new FormStepValidation(this);

  get titleOrDefault(): string {
    if (this.hasTitle) {
      return this.title;
    } else {
      let externalTitle = "External Form";
      if (this.dependent_form) {
        externalTitle = this.dependent_form.title;
      }
      return `Complete ${externalTitle}`;
    }
  }

  afterAppend(): void {
    super.afterAppend();
    this.setSubmitterToOriginalSubmitter();
  }

}
